import { Injectable } from '@angular/core';
import { AngularFirestore } from '@angular/fire/firestore';
import { combineLatest, of } from 'rxjs';
import { map, switchMap } from 'rxjs/operators';

import { environment } from '../../../environments/environment';
import { AuthService } from '../oauth0/oauth0.service';
import { BaseFirebaseService } from './base-firebase.service';
import { Project } from '@remodzy/types';

@Injectable({
  providedIn: 'root'
})
export class ProjectService extends BaseFirebaseService<Project> {
  constructor(
    auth: AuthService,
    db: AngularFirestore
  ) {
    super(auth, db, environment.firebase.collections.projects);
  }

  getScheduleProjects(start$: any, end$: any, isTimeSheet$: any, team$: any, showProjects$: any) {
    return combineLatest([start$, end$, isTimeSheet$, team$, showProjects$]).pipe(
      switchMap(([start, end, isTimeSheet, team, showProjects]) =>
        start != null && end != null && !isTimeSheet && showProjects ?
          this.db
            .collection(this.collectionName, ref => {
              let query: firebase.firestore.CollectionReference | firebase.firestore.Query = ref;
              query = query.where('tenantId', '==', this.auth.profile?.tenantId);
              if (start) {
                query = query.where('startDate', '>=', start);
              }
              if (end) {
                query = query.where('startDate', '<=', end);
              }
              query = query.where('teamId', '==', team === '' ? null : team);
              return query;
            })
            .stateChanges()
            .pipe(
              map((changes) => {
                return changes.map((doc) => this.mapStateFunction(doc));
              })
            )
          :
          of([])
      )
    );
  }
}
